import { gql } from '@apollo/client';
export const activeFileSystemQuery = gql `
  query ActiveFileSystem($folderId: ID!, $includeAncestors: Boolean!) {
    ancestors: fileSystemAncestors(id: $folderId) @include(if: $includeAncestors) {
      id
      name
      depth
    }

    folder: fileSystemFolder(id: $folderId) {
      id
      name
      depth
      acl: acls {
        id
        userId
        actions
      }
      teamAcls {
        id
        teamId
        actions
      }
    }
  }
`;
